"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/en-gb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePickerMonSun =
/*#__PURE__*/
function (_Component) {
  _inherits(DatePickerMonSun, _Component);

  function DatePickerMonSun(props) {
    var _this;

    _classCallCheck(this, DatePickerMonSun);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePickerMonSun).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "monSunBlur", function (event) {
      var enteredDate = (0, _moment.default)(event.target.value, "DD-MM-YYYY", true);

      if (!enteredDate.isValid()) {
        _this.setState({
          monSunDate: null,
          showMonSun: false
        }, function () {
          _this._calendar1.setSelected(null, event, false);
        });
      }

      document.getElementById(_this.props.id + "-show").classList.remove("hidden");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "monSunRaw", function (event) {
      var enteredDate = (0, _moment.default)(event.target.value, "DD-MM-YYYY", true);

      if (enteredDate.isValid()) {
        _this.setState({
          monSunDate: enteredDate,
          noDate: false
        });

        document.getElementById(_this.props.id + "-show").classList.remove("hidden");
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMonSunChange", function (date) {
      _this.setState({
        monSunDate: date,
        noDate: false
      });

      document.getElementById(_this.props.id + "-show").classList.remove("hidden");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearDatePicker", function (event) {
      event.preventDefault();
      event.persist();

      _this.setState({
        monSunDate: null,
        noDate: false,
        placeholder: "DD-MM-YYYY"
      }, function () {
        _this._calendar1.setSelected(null, event, false);
      });

      _this._calendar1.setOpen(false);

      document.getElementById(_this.props.id + "-show").classList.remove("hidden");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showMonSunCalendar", function (event) {
      _this.setState({
        showMonSun: true
      }, function () {
        document.getElementById(_this.props.id).focus();
      });

      document.getElementById(_this.props.id + "-show").classList.add("hidden");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hideMonSunCalendar", function (event) {
      _this.setState({
        showMonSun: false
      });

      document.getElementById(_this.props.id + "-show").classList.remove("hidden");
    });

    _this.state = {
      showMonSun: false,
      monSunDate: null,
      noDate: false,
      placeholder: "DD-MM-YYYY"
    };
    return _this;
  }

  _createClass(DatePickerMonSun, [{
    key: "clear",
    value: function clear() {
      var _this2 = this;

      this.setState({
        monSunDate: null,
        noDate: false,
        placeholder: "DD-MM-YYYY"
      }, function () {
        _this2._calendar1.setSelected(null, event, false);
      });

      this._calendar1.setOpen(false);

      document.getElementById(this.props.id + "-show").classList.remove("hidden");
    }
  }, {
    key: "monSunFocus",
    value: function monSunFocus() {
      if (!this.state.showMonSun) {
        this.showMonSunCalendar();
      }
    }
  }, {
    key: "getDate",
    value: function getDate() {
      if (this.state.noDate) {
        return "no date";
      } else {
        if (this.state.monSunDate) {
          return this.state.monSunDate.format("DD-MM-YYYY");
        } else {
          return "";
        }
      }
    }
  }, {
    key: "setNoDate",
    value: function setNoDate() {
      var _this3 = this;

      this.setState({
        noDate: true,
        placeholder: "No date",
        monSunDate: null
      }, function () {
        _this3._calendar1.setSelected(null, event, false);
      });

      this._calendar1.setOpen(false);

      document.getElementById(this.props.id + "-show").classList.remove("hidden");
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, this.props.title), _react.default.createElement("div", {
        className: "input-btn-wrapper"
      }, _react.default.createElement(_reactDatepicker.default, {
        id: this.props.id,
        dateFormat: "DD-MM-YYYY",
        selected: this.state.monSunDate,
        onChange: this.handleMonSunChange,
        onChangeRaw: this.monSunRaw,
        onBlur: this.monSunBlur,
        onFocus: this.monSunFocus.bind(this),
        ref: function ref(c) {
          return _this4._calendar1 = c;
        },
        locale: "en-gb",
        className: "form-control datepicker",
        popperPlacement: "bottom-end",
        placeholderText: this.state.placeholder
      }, _react.default.createElement("div", {
        className: "date-picker-footer-container"
      }, _react.default.createElement("a", {
        href: "",
        className: "date-picker-footer",
        onClick: this.clearDatePicker
      }, "Clear"), _react.default.createElement("a", {
        className: this.props.noDateOption ? "date-picker-footer-no-date regular-link-text" : "hidden",
        onClick: function onClick() {
          return _this4.setNoDate();
        }
      }, "No date"))), _react.default.createElement("button", {
        type: "button",
        id: "".concat(this.props.id, "-hide"),
        className: "select-btn date-picker-select-position",
        onClick: this.hideMonSunCalendar
      }, _react.default.createElement("span", {
        className: "fa fa-calendar"
      })), _react.default.createElement("button", {
        type: "button",
        id: "".concat(this.props.id, "-show"),
        className: "select-btn date-picker-select-position",
        onClick: this.showMonSunCalendar
      }, _react.default.createElement("span", {
        className: "fa fa-calendar"
      }))));
    }
  }]);

  return DatePickerMonSun;
}(_react.Component);

var _default = DatePickerMonSun;
exports.default = _default;